export default __webpack_public_path__ + "assets/audios/53bca276d57a71ad51e7ba96da265380.mp3";